// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ecl-card__image{margin:1rem auto;margin-bottom:4ch;height:11rem;width:13rem;background-size:contain;background-repeat:no-repeat;background-size:cover;background-position:50%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
